import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverflowText } from "@transfr-inc/dashboard-components";
import certificateIcon from "../../../../public/images/certificate-icon.png";
import microcredentialIcon from "../../../../public/images/microcredential-icon.png";
import { getCredentialType } from "@components/common/programs/programs.utils";

const getAwardIcon = (type) => {
  switch (type) {
    case 1:
      return (
        <img className="award-icon" src={certificateIcon} alt="Certificate" />
      );
    case 2:
      return (
        <img
          className="award-icon"
          src={microcredentialIcon}
          alt="Microcredential"
        />
      );
    case 3:
      return (
        <img className="award-icon" src={microcredentialIcon} alt="Badge" />
      );
    default:
      return null;
  }
};

export const AwardItem = ({ award, onClick }) => {
  return (
    <button
      className="award-item"
      key={award.credentialId}
      onClick={() => onClick(award)}
    >
      <div className="award-item-content">
        <div className="award-item-icon">{getAwardIcon(award.type)}</div>
        <div className="award-item-info">
          <OverflowText
            className="subtitle"
            text={getCredentialType(award.type)}
          >
            {getCredentialType(award.type)}
          </OverflowText>
          <OverflowText className="main-title" text={award.title}>
            {award.title}
          </OverflowText>
        </div>
      </div>
      <FontAwesomeIcon icon={["fa-solid", "arrow-up-right-from-square"]} />
    </button>
  );
};
